/**
 * DuitNow icon URL
 * Malaysia's national real-time payment system
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const DUITNOW_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/4Iq13VoxktB3amHFbQK1yb/f2fe12add0dac233d56c22cf5651c65c/image-20220630-030728.png';
